import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { matchPath } from 'react-router-dom';
import {
  View,
  // Platform,
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
// import { Auth } from '@aws-amplify/auth';
import {
  signIn, signInWithRedirect, getCurrentUser, fetchUserAttributes, AuthError,
} from '@aws-amplify/auth';
import md5 from 'md5';

import { translate } from '../../locales/i18n';
import styles from '../../styles';
import SignInForm from '../../components/forms/user/SignInForm';
import AORTypes from '../../types';

class SignIn extends React.Component {
  static async retrieveEmail() {
    try {
      const value = await AsyncStorage.getItem('email');
      if (value !== null && value !== undefined) {
        // Our data is fetched successfully
        console.log('retrieveEmail succeeded');
        console.log(value);
        return value;
      }
    } catch (error) {
      // Error retrieving data
      console.log('retrieveEmail failed');
      console.log(error);
    }

    return '';
  }

  static async storeEmail(email) {
    if (!email) {
      return;
    }

    try {
      await AsyncStorage.setItem('email', email);
    } catch (error) {
      // Error saving data
    }
  }

  static async retrievePassword() {
    try {
      const value = await AsyncStorage.getItem('password');
      if (value !== null && value !== undefined) {
        // Our data is fetched successfully
        console.log('retrievePassword succeeded');
        // console.log(value);
        return value;
      }
    } catch (error) {
      // Error retrieving data
      console.log('retrievePassword failed');
      console.log(error);
    }

    return '';
  }

  static async storePassword(password) {
    if (!password) {
      return;
    }

    try {
      await AsyncStorage.setItem('password', password);
    } catch (error) {
      // Error saving data
    }
  }

  constructor(props, context) {
    super(props, context);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'SignIn';

    this.onSubmit = this.onSubmit.bind(this);
    this.signInGoogle = this.signInGoogle.bind(this);

    this.state = {
      email: '',
      password: '',
    };
  }

  componentDidMount() {
    const { history, user } = this.props;
    const redirect = this.getRedirect();

    if (user && user.username) {
      if (user.attributes.email_verified) {
        history.push(redirect);
      } else {
        history.push(`/confirm${redirect}`);
      }
    }

    (async () => {
      await SignIn.retrieveEmail().then((email) => this.setState({ email }));
      await SignIn.retrievePassword().then((password) => this.setState({ password }));
    })();
  }

  componentDidUpdate(_prevProps) {
    const { history, user } = this.props;
    const redirect = this.getRedirect();

    if (user && user && user.username) {
      if (user.attributes.email_verified) {
        history.push(redirect);
      } else {
        history.push(`/confirm${redirect}`);
      }
    }
  }

  onSubmit(values) {
    const { history, getAnalyticsService } = this.props;
    const redirect = this.getRedirect();

    getAnalyticsService().report.event('loginAttempt', 'create');

    const username = md5(values.email.trim());
    const password = values.password.trim();

    return signIn({ username, password })
      .then((data) => {
        console.log('signIn success');
        console.log(data);

        if (!data.isSignedIn) {
          getAnalyticsService().report.event('loginFailure', 'user');
          this.setState({ email: values.email });
          return null;
        }

        const p1 = SignIn.storeEmail(values.email.trim()).catch(() => null);
        const p2 = SignIn.storePassword(values.password).catch(() => null);

        // TODO(clairbee): If we have signed in, then it's already confirmed.
        // TODO(clairbee): let 'Authentication.js' take care of this
        return fetchUserAttributes()
          .then((attributes) => {
            if (attributes.email_verified) {
              getAnalyticsService().report.event('loginSuccess', 'user');
              Promise.all([p1, p2]).then(() => {
                history.push(redirect);
              });
            } else {
              getAnalyticsService().report.event('loginConfirm', 'user');
              Promise.all([p1, p2]).then(() => {
                history.push(`/confirm${redirect}`);
              });
            }

            return null;
          })
          .catch((err) => {
            console.log(err);
            getAnalyticsService().report.event('loginFailed2', 'user');
            getAnalyticsService().report.error(err);

            let error = err.message;
            if (err.code === 'LimitExceededException') {
              error = translate('signin_error_limit');
            }
            this.setState({ email: values.email });

            return error;
          });
      })
      .catch((err) => {
        console.log(err);
        getAnalyticsService().report.event('loginFailed', 'user');
        getAnalyticsService().report.error(err);

        let error = err.message;
        if (err.code === 'LimitExceededException') {
          error = translate('signin_error_limit');
        }
        this.setState({ email: values.email });

        return error;
      });
  }

  // eslint-disable-next-line class-methods-use-this
  getRedirect() {
    const { location, forced } = this.props;

    const pattern = forced ? '/*' : '/signin/*';

    const match = matchPath(pattern, location.pathname);
    const result = match ? `/${match.params['*']}` : '/';
    console.log('location.pathname', location.pathname);
    console.log('pattern', pattern);
    console.log('match', match);
    console.log('getRedirect', result);
    return result;
  }

  async signInGoogle(userInfo) {
    const { history, getAnalyticsService } = this.props;
    const redirect = this.getRedirect();

    getAnalyticsService().report.event('loginGoogleAttempt', 'create');
    console.log('userInfo', userInfo);
    console.log('redirect', redirect);

    // redirect = `https://aionrails.com/auth/google/${redirect}`;
    const promise = signInWithRedirect({
      provider: 'Google',
      customState: redirect && redirect.length > 0 ? redirect : undefined,
    });
    // if (!userInfo /* Platform.OS === 'web' */) {
    //   promise = signInWithRedirect({ provider: 'Google', customState: redirect && redirect.length > 0 ? redirect : undefined });
    // } else {
    //   // this 'else' branch is for logging in with '@react-native-community/google-signin'
    //   // TODO(clairbee): DO NOT PERFORM federatedSignIn(), login into the user pool instead !!! how???
    //   promise = Auth.federatedSignIn(
    //     'accounts.google.com',
    //     {
    //       token: userInfo.idToken,
    //       expires_at: userInfo.accessTokenExpirationDate,
    //       // expires_at: 60 * 60 * 24 * 30 * 6 + new Date().getTime(), // the expiration timestamp
    //     },
    //     userInfo.user
    //   );
    // }

    const ret = await promise
      .then((cred) => {
        if (cred) {
          getAnalyticsService().report.event('loginGoogleSuccess', 'create');
        }
        // If success, you will get the AWS credentials
        console.log('cred', cred);
        return getCurrentUser({ bypassCache: true });
      })
      .then((user) => {
        // If success, the user object you passed in Auth.federatedSignIn
        console.log('user after federated login', user);

        // const oauthOrig = JSON.parse(JSON.stringify(AmplifyConfig.Auth.Cognito.loginWith.oauth));
        // Auth.configure({ oauth: oauthOrig });

        // TODO(clairbee): inspect the user attributes to determine if the user has to be forced to the federated registration page
        // TODO(clairbee): let 'Authentication.js' take care of this
        if (user.signInDetails.attributes.email_verified) {
          getAnalyticsService().report.event('loginGoogleSuccess2', 'user');
          history.push(redirect); // if we arrived here, then we are already logged in and, thus, the account is already created and initialized
        } else {
          history.push(`/confirm${redirect}`);
        }

        return null;
      })
      .catch((e) => {
        getAnalyticsService().report.event('loginGoogleFailure', 'create');
        console.log('federated login error', e);

        if (e instanceof AuthError && e.message.indexOf('There is already a signed in user') !== -1) {
          history.push(redirect);
        } else if (e instanceof AuthError && e.message.indexOf('User is not confirmed') !== -1) {
          history.push(`/confirm${redirect}`);
        }
      });
    console.log('ret');
    console.log(ret);
  }

  render() {
    const { history } = this.props;
    const redirect = this.getRedirect();
    const { email, password } = this.state;

    return (
      <View style={styles.view.headed}>
        <SignInForm
          email={email}
          password={password}
          redirect={redirect}
          history={history}
          onSubmit={this.onSubmit}
          signInGoogle={this.signInGoogle}
        />
      </View>
    );
  }
}

SignIn.defaultProps = {
  user: undefined,
  forced: false,
};

SignIn.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  getAnalyticsService: PropTypes.func.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  user: AORTypes.User,
  forced: PropTypes.bool,
};

export default SignIn;
